import { Button } from '@service-victoria/component-library/components/Button';
import Body from '@service-victoria/component-library/components/Text/Body';
import Heading from '@service-victoria/component-library/components/Text/Heading';
import React from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';

import FeedbackSurvey from 'Components/FeedbackSurvey';
import { CallToActionContainer } from 'Components/KioskRegistration/KioskRegistration';
import Page from 'Components/Page';
import { useFeatureToggles, useRegisteredLocations } from 'hooks';
import useModal from 'hooks/useModal';
import { constants } from 'utils';
import { trackEvent } from 'utils/analytics';
import { Routes } from 'utils/constants';

import * as Styled from './styled';

const RegistrationSuccess = () => {
  const location = useLocation<{ transactionId?: string }>();
  const { selectedLocation } = useRegisteredLocations();
  const history = useHistory();
  const modal = useModal();
  const showBookmarkModal = useFeatureToggles('showBookmarkModal');

  const openCheckInNewTab = () => {
    trackEvent({
      label: 'successOpenWebForm',
      action: 'KioskAdmin'
    });
    history.push(Routes.CheckIn);

    showBookmarkModal &&
      modal.open({
        title: 'Your kiosk check-in is now ready',
        children: (
          <>
            <Body>Bookmark this page for quick access on this device.</Body>
            <Body>
              <Button style={{ margin: '80px 40px -60px auto' }} onClick={modal.close}>
                Close
              </Button>
            </Body>
          </>
        )
      });
  };

  if (!selectedLocation) {
    return <Redirect to={Routes.Register} />;
  }

  return (
    <Page banner={{ title: constants.Page.registrationTitle }}>
      <Styled.HeadingWrapper>
        <Styled.CircleTickIcon data-testid='TickIcon' />
        <Heading.H2 fontWeight='bold' data-testid='PageHeading'>
          Success
        </Heading.H2>
      </Styled.HeadingWrapper>
      <Heading.H3 fontWeight={600} data-testid='PageHeading3'>
        {selectedLocation.businessName} your check-in form is ready
      </Heading.H3>
      <Body data-testid='PageBody'>
        This is the device you will be using for the check-in form.
      </Body>
      <CallToActionContainer>
        <Button onClick={openCheckInNewTab} data-testid='OpenCheckinButton'>
          Open check-in
        </Button>
      </CallToActionContainer>
      <FeedbackSurvey transactionId={location.state?.transactionId} />
    </Page>
  );
};

export default RegistrationSuccess;
